import { Box, Typography } from "@mui/material";
import React from "react";
import { NotificationFullData } from "../../layout/UserNotification";
import useThemeStore from "../../services/store/useThemeStore";
import { contentStyles, titleStyles, wrapperStyles } from "./BookingStarted";
import { DateNTime } from "../../utils/dateTime";
import { useTranslation } from "react-i18next";

// const wrapperStyles = {
//   p: 2,
//   display: "flex",
//   flexDirection: "row",
//   alignItems: "center",
//   gap: "12px",
//   background: "linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)",
//   border: "1px solid #e2e8f0",
//   borderRadius: "12px",
//   boxShadow:
//     "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
//   transition: "all 0.3s ease-in-out",
//   "&:hover": {
//     transform: "translateY(-2px)",
//     boxShadow:
//       "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
//     border: "1px solid #3b82f6",
//   },
// };

// const iconBoxStyles = {
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "center",
//   minWidth: 48,
//   minHeight: 48,
//   borderRadius: "50%",
//   background: "linear-gradient(135deg, #ffedd5 0%, #fed7aa 100%)",
//   border: "2px solid #ea580c",
//   boxShadow: "0 2px 4px rgba(234, 88, 12, 0.2)",
// };

// const contentStyles = {
//   flex: 1,
//   display: "flex",
//   flexDirection: "column",
//   gap: "8px",
//   textAlign: "left",
// };

// const titleStyles = {
//   font: "var(--semibold-sm)",
//   color: "#ea580c",
//   fontWeight: 600,
// };

const BookingInvite = ({
  notification,
}: {
  notification: NotificationFullData;
}) => {
  const { darkMode } = useThemeStore();
  const { t } = useTranslation();
  return (
    <Box sx={wrapperStyles(darkMode)}>
      {/* <Box sx={iconBoxStyles(darkMode)}>
        <Mail sx={{ color: "#ea580c", fontSize: 24 }} />
      </Box> */}
      <Box sx={contentStyles}>
        <Typography sx={titleStyles(darkMode)}>
          {t("booking_invite", { ns: "notification" })}
        </Typography>
        <Typography
          sx={{ color: "#64748b", font: "var(--body-xs)", fontWeight: 400 }}
        >
          {notification.message}
        </Typography>
        {notification?.created_at && (
          <Typography
            sx={{
              font: "var(--semibold-xxs)",
              color: darkMode ? "#9ca3af" : "#64748b",
              fontWeight: 500,
            }}
          >
            {DateNTime.formatRelative(notification.created_at)}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default BookingInvite;
